module.exports = __webpack_public_path__ + "img/target_tax.d95f626d.svg";